// NOTE: Refer DsToggleButtonGroup for Overrides
export const DsSwitchOverrides = {};
